import React, { useEffect, useState } from 'react'
import { parsePositiveNumber } from '../../utils/number'

const POSITIVE_FLOAT_MAX_3_RADIX = /^[0-9]*(\.|,)?[0-9]{0,3}$/

export const NumericInput = props => {
  const { value, onChange, onBlur } = props

  const [inputValue, setInputValue] = useState(value)

  useEffect(() => {
    setInputValue(value)
  }, [value])

  const handleChange = event => {
    const {
      target: { value: targetValue }
    } = event

    if (!targetValue || POSITIVE_FLOAT_MAX_3_RADIX.test(targetValue)) {
      setInputValue(targetValue)
    }
    onChange?.(event)
  }

  const handleClick = event => event.target.focus()

  const handleBlur = () => {
    const event = {
      target: {
        value: parsePositiveNumber(inputValue, 3)
      }
    }
    onBlur?.(event)
  }

  return (
    <input
      {...props}
      value={inputValue}
      type="number"
      onClick={handleClick}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  )
}

export default NumericInput
